export const engagementAppGroupIdGetEmailClientMetadataId =
  "/engagement/:app_group_id/get_email_client_metadata/:id";
